import { render, staticRenderFns } from "./safety-supervision-inspecion-update.vue?vue&type=template&id=ed354c3e&scoped=true&"
import script from "./safety-supervision-inspecion-update.vue?vue&type=script&lang=js&"
export * from "./safety-supervision-inspecion-update.vue?vue&type=script&lang=js&"
import style0 from "./safety-supervision-inspecion-update.vue?vue&type=style&index=0&id=ed354c3e&prod&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed354c3e",
  null
  
)

export default component.exports